export enum GlobalKeyEnum {
	CONNECT = 'connect',
}
export enum CategoryEnum {
	OUTBOUND_TASK = 'outbound_task',
	CALLNOTE = 'callnote',
	GENERAL = 'general',
	FEEDBACK = 'feedback',
	CALLER_CORRECTION = 'caller_correction',
}

export enum I18nKeyGeneralEnum {
	FRIDAY = 'label_friday',
	MONDAY = 'label_monday',
	SATURDAY = 'label_saturday',
	SUNDAY = 'label_sunday',
	THURSDAY = 'label_thursday',
	TUESDAY = 'label_tuesday',
	WEDNESDAY = 'label_wednesday',
	NO = 'no',
	YES = 'yes',
	CANCEL = 'cancel',
	NEW_FUNCTION = 'new_function',
	OK = 'ok',
	ERROR_PAST_DATE = 'error_past_date',
	ERROR_REQUIRED = 'error_required',
	ERROR_INVALID_DATE = 'error_invalid_date',
	ERROR_NO_BUSINESS_DAY = 'error_no_business_day',
	ERROR_MAX_LENGTH = 'error_max_length',
}

export enum I18nCallNoteEnum {
	CALLER_NUMBERS = 'caller_numbers',
	CALL_LABEL = 'call_label',
	CONTEXT_HEADER = 'contextHeader',
	LABEL_ANSPRECH_PARTNER = 'label_ansprechpartner',
	TELETYPE_ADDITIONAL = 'teletype_additional',
	TELETYPE_BIZ = 'teletype_biz',
	TELETYPE_EMAIL_ADDITIONAL = 'teletype_email_additional',
	TELETYPE_EMAIL_BIZ = 'teletype_email_biz',
	TELETYPE_EMAIL_MAIN = 'teletype_email_main',
	TELETYPE_EMAIL_PRIVATE = 'teletype_email_private',
	TELETYPE_FAX_ADDITIONAL = 'teletype_fax_additional',
	TELETYPE_FAX_BIZ = 'teletype_fax_biz',
	TELETYPE_FAX_MAIN = 'teletype_fax_main',
	TELETYPE_FAX_PRIVATE = 'teletype_fax_private',
	TELETYPE_MAIN = 'teletype_main',
	TELETYPE_MOBILE = 'teletype_mobile',
	TELETYPE_PHONE_ADDITIONAL = 'teletype_phone_additional',
	TELETYPE_PRIVATE = 'teletype_private',
}

export enum I18nOutboundTaskEnum {
	ACCEPT_VOICEMAIL = 'accept_voicemail',
	TIME_WARNING = 'time_warning',
	EARLIEST = 'earliest',
	THE_CALLER = 'the_caller',
	PREFIX_MALE = 'prefix_male',
	PREFIX_FEMALE = 'prefix_female',
	PREFIX_NEUTRAL = 'prefix_neutral',
	CALLBACK_CONDITION = 'callback_condition',
	CALLBACK_CONFIRMATION = 'callback_confirmation',
	CALLBACK_ERROR = 'callback_error',
	CALLBACK_PROMPT = 'callback_prompt',
	CALLBACK_QUESTION = 'callback_question',
	CALLBACK_QUESTION_CONTENT = 'callback_question_content',
	CALLBACK_QUESTION_END = 'callback_question_end',
	CALLBACK_QUESTION_TIME = 'callback_question_time',
	CALLBACK_SCHEDULE = 'callback_schedule',
	CALLBACK_SUCCESS = 'callback_success',
	CALLBACK_SUGGESTIONS_LABEL = 'callback_suggestions_label',
	CALLBACK_TIME_ASAP = 'callback_time_asap',
	EXISTING_OUTBOUND_TASK_IN_PROGRESS_WARN = 'existing_outbound_task_in_progress_warn',
	EXISTING_OUTBOUND_TASK_SCHEDULED_WARN = 'existing_outbound_task_scheduled_warn',
	NO_GENERATED_SUGGESTIONS = 'no_generated_suggestions',
	PAGE_TITLE = 'page_title',
	SCHEDULE_BUSINESS_HOURS = 'schedule_business_hours',
	SCHEDULE_NEXT_AVAILABLE_TIME = 'schedule_next_available_time',
	SCHEDULE_NO_BUSINESS_HOURS = 'schedule_no_business_hours',
	SCHEDULE_OUT_OF_BUSINESS_HOURS = 'schedule_out_of_business_hours',
	OUTBOUND_INFO_TITLE = 'outbound_info_title',
	OUTBOUND_INFO_DESCRIPTION = 'outbound_info_description',
	OUTBOUND_PRICE_TITLE = 'outbound_price_title',
	OUTBOUND_PRICE_DESCRIPTION = 'outbound_price_description',
	ALTERNATIVE_SUGGESTIONS = 'alternative_suggestions',
	BUSINESS_HOUR = 'business_hour',
	INFO_PRICE_BTN = 'info_price_btn',
	CALL_BTN = 'call_btn',
	CALLBACK_REQUEST_GENERATED = 'callback_request_generated',
	ERROR_CALLBACK_REQUEST = 'error_callback_request',
	CALLBACK_TIME_INFORMATION = 'callback_time_information',
	VOICE_BOT_MODE_LABEL = 'voice_bot_mode_label',
	VOICE_BOT_MODE_ALWAYS_AI = 'voice_bot_mode_always_ai',
	VOICE_BOT_MODE_ALWAYS_HUMAN = 'voice_bot_mode_always_human',
}

export enum I18nFeedbackEnum {
	FEEDBACK_THANK_YOU = 'thank_you',
	FEEDBACK_INFO_TEXT = 'feedback_info_text',
	FEEDBACK_RATING_LABEL = 'rating_label',
	FEEDBACK_SUBMIT = 'submit',
	FEEDBACK_SAVED_SUCCESS = 'saved_success',
	FEEDBACK_CALLBACK_WISH = 'callback_wish',
	FEEDBACK_COMMENT_PLACEHOLDER = 'comment_placeholder',
	FEEDBACK_CB_WRONG_NAME = 'cb_wrong_name',
	FEEDBACK_CB_WRONG_PHONE = 'cb_wrong_phone',
	FEEDBACK_CB_WRONG_NOTICE = 'cb_wrong_notice',
	FEEDBACK_CB_UNFRIENDLY = 'cb_unfriendly',
	FEEDBACK_CB_ORDERS_IGNORED = 'cb_orders_ignored',
	FEEDBACK_RATE_DISAPPOINTING = 'rate_disappointing',
	FEEDBACK_RATE_NOT_GOOD = 'rate_not_good',
	FEEDBACK_RATE_OK = 'rate_ok',
	FEEDBACK_RATE_GOOD = 'rate_good',
	FEEDBACK_RATE_EXTRAORDINARY = 'rate_extraordinary',
	FEEDBACK_NEGATIVE_ASPECTS = 'negative_aspects',
	FEEDBACK_CALLBACK_PHONE = 'callback_phone',
	FEEDBACK_CALLBACK_PHONE_HINT = 'callback_phone_hint',
	FEEDBACK_SAVE_ERROR = 'save_error',
	FEEDBACK_EDIT_UNAVAILABLE = 'edit_unavailable',
}

export enum I18nCallerCorrectionEnum {
	CORRECT_DIALOG_TITLE = 'dialog_title',
	CORRECT_SALUTATION = 'salutation',
	CORRECT_FIRSTNAME = 'firstname',
	CORRECT_LASTNAME = 'lastname',
	CORRECT_COMPANY = 'company',
	CORRECT_PHONE_TYPE = 'phone_type',
	CORRECT_PHONE_NUMBER = 'phone_number',
	CORRECT_SAVE = 'save',
	CORRECT_CANCEL = 'cancel',
	CORRECT_SUCCESS = 'success',
	CORRECT_ADD_TO_ADDRESSBOOK = 'add_to_addressbook',
	CORRECT_SYNC_UPDATE = 'sync_update',
	CORRECT_SYNC_UNLINK = 'sync_unlink',
	CORRECT_SYNC_CREATE_NEW = 'sync_create_new',
	CORRECT_VALIDATION_NAME_OR_COMPANY = 'validation_name_or_company',
}

export enum LanguageEnum {
	DE = 'DE',
	EN = 'EN',
}

export type GlobalKey = GlobalKeyEnum;

export type I18nGlobal = {
	[key in GlobalKey]: I18nCategory;
};

export type I18nCategory = {
	[cat in CategoryEnum]: Translation;
};

/**
 * PS-6495 - the guided SIP-Anschluss setup's strings, under `connect` / `outbound_task`.
 *
 * GENERATED FROM PS-6495-i18n-inserts.sql and kept in step with the recorded payload's
 * `connect` / `outbound_task` block (`mock-callnote.fixture.ts`) by `i18n.model.spec.ts`. Adding a
 * key here without the row, or the row without the key, is the failure this pairing exists to
 * catch: a key with no row resolves to an EMPTY STRING rather than an error, so nothing would go
 * red - the screen would simply lose a label.
 *
 * `sip_` prefix because this set shares a category with the rest of the outbound-task copy
 * (Torsten, 2026-10-09): the workflow belongs to the outbound task thematically, and a shared
 * category needs no new backend plumbing.
 */
export enum I18nSipSetupEnum {
	SIP_CONSENT_AGB = 'sip_consent_agb',
	SIP_CONSENT_WAIVER_TKG71 = 'sip_consent_waiver_tkg71',
	SIP_CONSENT_REQUIRED_NOTE = 'sip_consent_required_note',
	SIP_ORDER_TARIFF_NAME = 'sip_order_tariff_name',
	SIP_ORDER_INCLUDED_CONNECTION = 'sip_order_included_connection',
	SIP_ORDER_INCLUDED_CONTRACT_EXTENSION = 'sip_order_included_contract_extension',
	SIP_ORDER_INCLUDED_DISPLAY_NUMBER = 'sip_order_included_display_number',
	SIP_INTRO_NOTHING_CONFIGURED = 'sip_intro_nothing_configured',
	SIP_INTRO_NUMBER_ONLY = 'sip_intro_number_only',
	SIP_INTRO_CONNECTION_ONLY = 'sip_intro_connection_only',
	SIP_NUMBER_INVALID = 'sip_number_invalid',
	SIP_LOGIN_REJECTED = 'sip_login_rejected',
	SIP_LOGIN_EXPIRED = 'sip_login_expired',
	/** PS-6646: the signed-in account does not own the callnote's phone service. */
	SIP_LOGIN_WRONG_ACCOUNT = 'sip_login_wrong_account',
	SIP_LOGIN_TWO_FACTOR_WRONG = 'sip_login_two_factor_wrong',
	SIP_LOGIN_TWO_FACTOR_HINT = 'sip_login_two_factor_hint',
	SIP_ERROR_CONSENT_TERMS = 'sip_error_consent_terms',
	SIP_ERROR_CONSENT_WAIVER = 'sip_error_consent_waiver',
	SIP_ERROR_CONSENT_BOTH = 'sip_error_consent_both',
	SIP_STEP_INTRO = 'sip_step_intro',
	SIP_STEP_SIGN_IN = 'sip_step_sign_in',
	SIP_STEP_CHOOSE_NUMBER = 'sip_step_choose_number',
	SIP_STEP_ORDER_SIP = 'sip_step_order_sip',
	SIP_STEP_CONFIRMATION = 'sip_step_confirmation',
	SIP_PROGRESS_STEP = 'sip_progress_step',
	SIP_SIGNED_IN_AS = 'sip_signed_in_as',
	SIP_CLOSE_SETUP = 'sip_close_setup',
	SIP_INTRO_TITLE = 'sip_intro_title',
	SIP_INTRO_INCLUDED_LEAD = 'sip_intro_included_lead',
	SIP_INTRO_NO_COST_NOTE = 'sip_intro_no_cost_note',
	SIP_SIGN_IN_TITLE = 'sip_sign_in_title',
	SIP_SIGN_IN_LEAD = 'sip_sign_in_lead',
	SIP_SIGN_IN_USERNAME = 'sip_sign_in_username',
	SIP_SIGN_IN_PASSWORD = 'sip_sign_in_password',
	SIP_SIGN_IN_TWO_FACTOR_CODE = 'sip_sign_in_two_factor_code',
	SIP_NUMBER_TITLE = 'sip_number_title',
	SIP_NUMBER_LEAD_CHOICES = 'sip_number_lead_choices',
	SIP_NUMBER_OPTION_OTHER = 'sip_number_option_other',
	SIP_NUMBER_LEAD_NO_CHOICES = 'sip_number_lead_no_choices',
	SIP_NUMBER_FIELD = 'sip_number_field',
	SIP_NUMBER_PLACEHOLDER = 'sip_number_placeholder',
	SIP_NUMBER_ALREADY_STORED = 'sip_number_already_stored',
	SIP_NUMBER_HINT = 'sip_number_hint',
	SIP_ORDER_TITLE = 'sip_order_title',
	SIP_ORDER_TARIFF_LABEL = 'sip_order_tariff_label',
	SIP_ORDER_PROVIDER_LABEL = 'sip_order_provider_label',
	SIP_ORDER_PROVIDER_NAME = 'sip_order_provider_name',
	SIP_ORDER_SIGNALLED_NUMBER_LABEL = 'sip_order_signalled_number_label',
	SIP_ORDER_MONTHLY_COST_LABEL = 'sip_order_monthly_cost_label',
	SIP_ORDER_PRICE_NOT_IN_TARIFF = 'sip_order_price_not_in_tariff',
	SIP_ORDER_PRICE_UNAVAILABLE = 'sip_order_price_unavailable',
	SIP_ORDER_INCLUDED_TITLE = 'sip_order_included_title',
	SIP_BOOKED_TITLE = 'sip_booked_title',
	SIP_BOOKED_DISPLAY_NUMBER_LABEL = 'sip_booked_display_number_label',
	SIP_BOOKED_DISPLAY_NUMBER_NOTE = 'sip_booked_display_number_note',
	SIP_BOOKED_SIP_NUMBER_LABEL = 'sip_booked_sip_number_label',
	SIP_BOOKED_CALLBACK_PENDING = 'sip_booked_callback_pending',
	SIP_REJECTED_TITLE = 'sip_rejected_title',
	SIP_REJECTED_LEAD = 'sip_rejected_lead',
	SIP_CONTACT_SERVICE = 'sip_contact_service',
	SIP_CALLBACK_NOT_ORDERED = 'sip_callback_not_ordered',
	SIP_FAILED_TITLE = 'sip_failed_title',
	SIP_FAILED_LEAD = 'sip_failed_lead',
	SIP_BTN_NOT_NOW = 'sip_btn_not_now',
	SIP_BTN_START = 'sip_btn_start',
	SIP_BTN_CANCEL = 'sip_btn_cancel',
	SIP_BTN_SIGN_IN = 'sip_btn_sign_in',
	SIP_BTN_SIGN_IN_BUSY = 'sip_btn_sign_in_busy',
	SIP_BTN_CONTINUE = 'sip_btn_continue',
	SIP_BTN_SAVE_AND_CALL = 'sip_btn_save_and_call',
	SIP_BTN_BACK = 'sip_btn_back',
	SIP_BTN_CONFIRM_ORDER = 'sip_btn_confirm_order',
	SIP_BTN_ORDERING_BUSY = 'sip_btn_ordering_busy',
	SIP_BTN_LATER = 'sip_btn_later',
	SIP_BTN_CALL_NOW = 'sip_btn_call_now',
	SIP_BTN_CLOSE = 'sip_btn_close',
	SIP_RESUME_BTN = 'sip_resume_btn',
	/** PS-6495 failure paths: the five keys added at the bottom of PS-6495-i18n-inserts.sql. */
	SIP_LOGIN_UNAVAILABLE = 'sip_login_unavailable',
	SIP_ORDER_UNCONFIRMED_TITLE = 'sip_order_unconfirmed_title',
	SIP_ORDER_UNCONFIRMED_LEAD = 'sip_order_unconfirmed_lead',
	SIP_CALLBACK_SERVICE_FOLLOW_UP = 'sip_callback_service_follow_up',
	SIP_BTN_CONTACT_SERVICE = 'sip_btn_contact_service',
	/**
	 * The contract address was unusable (PS-6605-i18n-inserts.sql).
	 *
	 * @ticket PS-6605
	 */
	SIP_ADDRESS_INVALID_TITLE = 'sip_address_invalid_title',
	SIP_ADDRESS_INVALID_LEAD = 'sip_address_invalid_lead',
	/** Number validation and own-number verification (PS-6589-i18n-inserts.sql). */
	SIP_STEP_VERIFY_NUMBER = 'sip_step_verify_number',
	SIP_INTRO_VERIFY_ONLY = 'sip_intro_verify_only',
	SIP_VALIDATE_NOT_GERMAN = 'sip_validate_not_german',
	SIP_VALIDATE_MOBILE = 'sip_validate_mobile',
	SIP_VALIDATE_PREMIUM = 'sip_validate_premium',
	SIP_VALIDATE_NOMADIC = 'sip_validate_nomadic',
	SIP_VALIDATE_NOT_FIXED_LINE = 'sip_validate_not_fixed_line',
	SIP_VALIDATE_INCOMPLETE = 'sip_validate_incomplete',
	SIP_VALIDATE_UNAVAILABLE = 'sip_validate_unavailable',
	SIP_BTN_CHECKING_NUMBER = 'sip_btn_checking_number',
	SIP_CONSENT_DECLARATION_TKG120 = 'sip_consent_declaration_tkg120',
	SIP_ERROR_CONSENT_DECLARATION = 'sip_error_consent_declaration',
	SIP_VERIFY_TITLE = 'sip_verify_title',
	SIP_VERIFY_LEAD = 'sip_verify_lead',
	SIP_VERIFY_NUMBER_LABEL = 'sip_verify_number_label',
	SIP_VERIFY_NUMBER_QUESTION = 'sip_verify_number_question',
	SIP_VERIFY_SIP_NUMBER_NOTE = 'sip_verify_sip_number_note',
	SIP_BTN_VERIFY_CALL = 'sip_btn_verify_call',
	SIP_BTN_VERIFY_BUSY = 'sip_btn_verify_busy',
	SIP_BTN_EDIT_NUMBER = 'sip_btn_edit_number',
	SIP_BTN_SKIP_VERIFICATION = 'sip_btn_skip_verification',
	SIP_VERIFY_RUNNING_TITLE = 'sip_verify_running_title',
	SIP_VERIFY_CODE_LABEL = 'sip_verify_code_label',
	SIP_VERIFY_STATUS_CALLING = 'sip_verify_status_calling',
	SIP_VERIFY_STATUS_ANSWERED = 'sip_verify_status_answered',
	SIP_VERIFY_VALID_FOR = 'sip_verify_valid_for',
	SIP_BTN_CANCEL_CALL = 'sip_btn_cancel_call',
	SIP_VERIFY_SUCCESS_TITLE = 'sip_verify_success_title',
	SIP_VERIFY_WRONG_CODE_TITLE = 'sip_verify_wrong_code_title',
	SIP_VERIFY_WRONG_CODE_LEAD = 'sip_verify_wrong_code_lead',
	SIP_VERIFY_NOT_REACHED_TITLE = 'sip_verify_not_reached_title',
	SIP_VERIFY_NOT_REACHED_LEAD = 'sip_verify_not_reached_lead',
	SIP_VERIFY_FAILED_TITLE = 'sip_verify_failed_title',
	SIP_VERIFY_FAILED_LEAD = 'sip_verify_failed_lead',
	SIP_VERIFY_LOCKED_TITLE = 'sip_verify_locked_title',
	SIP_VERIFY_LOCKED_LEAD = 'sip_verify_locked_lead',
	SIP_VERIFY_MANUAL_NOTE_LABEL = 'sip_verify_manual_note_label',
	SIP_BTN_REQUEST_MANUAL = 'sip_btn_request_manual',
	SIP_VERIFY_MANUAL_SENT = 'sip_verify_manual_sent',
	SIP_VERIFY_RATE_LIMITED_TITLE = 'sip_verify_rate_limited_title',
	SIP_VERIFY_RATE_LIMITED_LEAD = 'sip_verify_rate_limited_lead',
	SIP_VERIFY_IN_FLIGHT_TITLE = 'sip_verify_in_flight_title',
	SIP_VERIFY_IN_FLIGHT_LEAD = 'sip_verify_in_flight_lead',
	SIP_VERIFY_NOT_POSSIBLE_TITLE = 'sip_verify_not_possible_title',
	SIP_VERIFY_NOT_POSSIBLE_LEAD = 'sip_verify_not_possible_lead',
	SIP_VERIFY_AUTO_CONTINUE = 'sip_verify_auto_continue',
	SIP_VERIFY_VERIFIED_CHIP = 'sip_verify_verified_chip',
	SIP_BTN_TRY_AGAIN = 'sip_btn_try_again',
	SIP_BOOKED_UNVERIFIED_LABEL = 'sip_booked_unverified_label',
	SIP_SUCCESS_TITLE = 'sip_success_title',
	/** SIP order link result screens. */
	SIP_LINK_EXPIRED_TITLE = 'sip_link_expired_title',
	SIP_LINK_EXPIRED_LEAD = 'sip_link_expired_lead',
	SIP_LINK_ORDER_FAILED_LEAD = 'sip_link_order_failed_lead',
	SIP_LINK_NOT_ORDERABLE_TITLE = 'sip_link_not_orderable_title',
	SIP_LINK_NOT_ORDERABLE_LEAD = 'sip_link_not_orderable_lead',
}

export type I18nItem =
	| I18nKeyGeneralEnum
	| I18nCallNoteEnum
	| I18nOutboundTaskEnum
	| I18nSipSetupEnum
	| I18nFeedbackEnum
	| I18nCallerCorrectionEnum;

export type I18nItems = {
	[localName in I18nItem]: Translation;
};

export interface Translation {
	translation: string;
	fallback: string;
}

export const I18nKeys = {
	...I18nKeyGeneralEnum,
	...I18nCallNoteEnum,
	...I18nOutboundTaskEnum,
	...I18nSipSetupEnum,
	...I18nFeedbackEnum,
	...I18nCallerCorrectionEnum,
};
